import {
  StyledEngineProvider,
  Theme,
  ThemeProvider,
} from '@mui/material/styles';

declare module '@mui/styles/defaultTheme' {
  // eslint-disable-next-line @typescript-eslint/no-empty-interface
  interface DefaultTheme extends Theme {}
}

declare module '@mui/material/styles' {
  interface Palette {
    icon?: Palette['primary'];
  }
  interface PaletteOptions {
    icon?: PaletteOptions['primary'];
  }
}

const withTheme =
  (ComponentDefinition: React.ComponentType<any>, theme: Theme) =>
  (props: any) =>
    (
      <StyledEngineProvider injectFirst>
        <ThemeProvider theme={theme}>
          <ComponentDefinition {...props} />
        </ThemeProvider>
      </StyledEngineProvider>
    );

export default withTheme;
